/* angular:styles/component:css;fa715c1b96e651b7df04cad6b674026f8e51e14b1423ae74493b3642ab510a49;/src/src/app/shared/components/pick-date-time-range/pick-date-time-range.ts */
.time-display-item {
  border: 0.067em;
  border-radius: 1em;
  border-style: solid;
  text-align: center;
}
/*# sourceMappingURL=pick-date-time-range.css.map */
